import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "badge-control inline-flex h-6 items-center rounded-full border px-2.5 text-xs font-semibold tracking-[-0.01em] transition-[color,background-color,border-color,box-shadow,transform] duration-standard ease-standard focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-secondary-fixed text-on-secondary-fixed",
        secondary:
          "border-border-standard bg-surface-container-low font-mono text-text-secondary",
        outline: "border-border-standard text-text-secondary",
        success:
          "border-transparent bg-success-container text-on-success-container",
        warning:
          "border-transparent bg-warning-container text-on-warning-container",
        danger: "border-transparent bg-error-container text-on-error-container",
        copper:
          "border-transparent bg-primary-fixed font-mono text-on-primary-fixed-variant",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
